import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromNotifyIndividual from '../reducers/notify-individual.reducer';

export { NotifyIndividualState } from '../reducers/notify-individual.reducer';

export const selectNotifyIndividualState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromNotifyIndividual.notifyIndividualFeatureKey]
);

export const selectNotifyIndividualOutstandingSuccess = createSelector(
  selectNotifyIndividualState,
  (state) => state?.success
);

export const selectNotifyIndividualOutstandingFailure = createSelector(
  selectNotifyIndividualState,
  (state) => state?.failure
);

export const selectNotifyIndividualOutstandingLoading = createSelector(
  selectNotifyIndividualState,
  (state) => state?.loading
);
